export default __webpack_public_path__ + "static/media/hood_of_fiendish_invocation.046fa072.jpg";